import { settings } from '../../constants/settings.js';
import { assert } from '../../utils/assert.js';
import { computeTotalBalanceDifferentDecimals, compareAmounts, adjustDecimals } from '../../utils/tokenUtils.js';
import { getQuote } from '../solverRelay/getQuote.js';
import { aggregateQuotes } from './aggregateQuotes.js';
import { calculateSplitAmounts } from './calculateSplitAmounts.js';

async function getAggregatedQuoteExactIn({ aggregatedQuoteParams, config = {}, }) {
    const tokenOut = aggregatedQuoteParams.tokenOut;
    const tokenIn = aggregatedQuoteParams.tokensIn[0];
    assert(tokenIn != null, "tokensIn is empty");
    const totalAvailableIn = computeTotalBalanceDifferentDecimals(aggregatedQuoteParams.tokensIn, aggregatedQuoteParams.balances);
    // If total available is less than requested, just quote the full amount from one token
    if (totalAvailableIn == null ||
        compareAmounts(totalAvailableIn, aggregatedQuoteParams.amountIn) === -1) {
        const exactAmountIn = adjustDecimals(aggregatedQuoteParams.amountIn.amount, aggregatedQuoteParams.amountIn.decimals, tokenIn.decimals);
        const quoteParams = {
            defuse_asset_identifier_in: tokenIn.defuseAssetId,
            defuse_asset_identifier_out: tokenOut.defuseAssetId,
            exact_amount_in: exactAmountIn.toString(),
            min_deadline_ms: settings.quoteMinDeadlineMs,
            wait_ms: aggregatedQuoteParams.waitMs,
        };
        const q = getQuote({
            quoteParams,
            config: {
                ...config,
                logBalanceSufficient: false,
            },
        });
        return {
            ...aggregateQuotes(await Promise.allSettled([q]), [quoteParams]),
            isSimulation: true,
        };
    }
    const amountsToQuote = calculateSplitAmounts(aggregatedQuoteParams.tokensIn, aggregatedQuoteParams.amountIn, aggregatedQuoteParams.balances);
    const { quotes, quoteParams } = await fetchQuotesForTokens(tokenOut.defuseAssetId, amountsToQuote, aggregatedQuoteParams.waitMs, {
        ...config,
        logBalanceSufficient: true,
    });
    return aggregateQuotes(quotes, quoteParams);
}
async function fetchQuotesForTokens(tokenOut, amountsToQuote, waitMs, config) {
    const quoteParams = Object.entries(amountsToQuote).map(([tokenIn, amountIn]) => {
        return {
            defuse_asset_identifier_in: tokenIn,
            defuse_asset_identifier_out: tokenOut,
            exact_amount_in: amountIn.toString(),
            min_deadline_ms: settings.quoteMinDeadlineMs,
            wait_ms: waitMs,
        };
    });
    const quotes = await Promise.allSettled(quoteParams.map((quoteParams) => getQuote({ quoteParams, config })));
    return { quotes, quoteParams };
}

export { getAggregatedQuoteExactIn };
//# sourceMappingURL=getAggregatedQuoteExactIn.js.map
